import type BrandingData from '../interfaces/BrandingData';

export interface BrandingDataSlice {
  brandingData: BrandingData | null;
  setBrandingData: (data: BrandingData) => void;
}

export const createBrandingDataSlice = (set: any, _: any): BrandingDataSlice => ({
  brandingData: null,
  setBrandingData: (data) => set({ brandingData: data }),
});
